module.exports = __webpack_public_path__ + "img/dengnavicon1.385e6895.png";